import Choices from 'choices.js';

// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
export default () => {
  Array.from(document.getElementsByClassName('choices')).forEach((element) => {
    // eslint-disable-next-line no-new
    new Choices(element, {
      delimiter: ',',
      removeItemButton: true,
      noChoicesText: '選択されていません',
      itemSelectText: '選択してください',
    });
  });
};
